import { element } from 'angular';
export const getInjector = () => {
    const $root = element(document.documentElement);
    return (!$root || !$root.injector) ? null : $root.injector();
};

//# sourceMappingURL=injector.js.map
